
/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { DropDownList, MultiSelect } from '@progress/kendo-react-dropdowns';
import { Field, Form, FormElement } from '@progress/kendo-react-form';
import { useLocation, useNavigate } from 'react-router-dom';
import * as API from "../../framework/API/api"
import { BA_ACTION, CONTENT_CUSTOM_ENUM, ENTITYNAME, LOCALSTORAGE_KEY, MEDIA_TRANSMISSION, MEDIACATEGORIES, TOAST_TYPES } from '../../framework/constant/constant';
import { Checkbox } from '@progress/kendo-react-inputs';
import CollectionSelection from '../../framework/forms/CollectionSelection';
import { TimePickerWithFormat } from '../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat';
import { utility } from '../../framework/utility/utilityProvider';
import { useTranslation } from '../../locale/useTranslation';
import SaveButton from '../../framework/forms/helpercomponents/buttons/SaveButton';
import CancelButton from '../../framework/forms/helpercomponents/buttons/CancelButton';
import InfoRoundButton from '../../components/InfoRoundButton';
import { ContentEditForm } from '../masters/ContentEditForm';
import { history } from '../../components/history';
import LanguageTranslator from '../../components/LanguageTranslator';
import { GenreEditForm } from '../masters/GenreEditForm';
import { ConfirmAlert } from '../../ConfirmAlert';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import MMImageEditForm from './MMImageEditForm';
import ImageCard from './component/ImageCard';
import MediaHeroCard from './component/MediaHeroCard';
import BossDialog from '../../components/BossDialog';
import TooltipInfoCard from '../../components/TooltipInfoCard';
import BossAssistantIcon from './component/BossAssistantIcon';
import { DataHelper } from '../../framework/helper/DataHelper';
import MediaEpisodeSettingForm from './MediaEpisodeSettingForm';
import MyMultiSelect from '../../components/MyMultiSelect';
import moment from 'moment';
import ToastNotification from '../../components/ToastNotification';
import TMDBEditForm from './TMDBEditForm';

const SeasonDetailForm = ({ dataItem, setDataItem, selectedSeries, setSelectedSeries, isArchiveChanged, setIsArchiveChanged, createEpisodeDataItem, setCreateEpisodeDataItem, entityName, ...props }) => {

  const lang = useTranslation();

  const location = useLocation();

  const [content, setContent] = useState([]);
  const [episodeContent, setEpisodeContent] = useState([]);
  const [openImageBank, setOpenImageBank] = useState(false);
  const [openImageBrowse, setOpenImageBrowse] = useState(false);
  const [openSeriesSelection, setOpenSeriesSelection] = useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState('https://i.postimg.cc/j5PsF5jZ/defaultmovie.png');
  const [disableEpsiodeFields, setDisableEpsiodeFields] = useState(true)
  // const [mediaCategory, setMediaCategory] = useState([]);
  const [showTranslateForm, setShowTranslateForm] = useState(false);
  const [genres, setGenres] = useState([]);
  const [currentUserChannels, setCurrentUserChannels] = useState([]);
  const [openImageInput, setOpenImageInput] = useState(false);
  const [openTMDB, setOpenTMDB] = useState(false);

  const defaultFormState = {
    Content: false,
  }
  const [showEditForm, setShowEditForm] = useState(defaultFormState);
  const [transmissions, setTransmissions] = useState([]);
  const [openMediaEpisodeSettingForm, setOpenMediaEpisodeSettingForm] = useState(false);
  const [targetGroups, setTargetGroups] = useState([]);
  const [providers, setProviders] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [countries, setCountries] = useState([]);
  const [dropdownFilters, setDropdownFilters] = useState({
    Genres: '',
    SubGenres: '',
    Languages: '',
    DubbedLanguages: ''
  });
  const [platforms, setPlatforms] = useState([]);
  const [channels, setChannels] = useState([]);
  const [selectAllChannels, setSelectAllChannels] = useState(false);
  const [pgRatings, setPgRatings] = useState([]);
  const [selectAllPlatforms, setSelectAllPlatforms] = useState(false);

  //on create new entity and edit quickEdit is false but on quickEdit click quickEdit is true
  const [openForm, setFormOpen] = useState((dataItem.SID == 0 && !props?.isFromAddProgram) || props.quickEdit || props?.isManageContent);
  const [showSeasonOverview, setShowSeasonOverview] = useState(dataItem.SID == 0 ? true : false);

  const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
  const isEtisalat = company && company.Name && company.Name.toLowerCase() == "etisalat";
  const isEncompass = company && company.Name && company.Name.toLowerCase() == "encompass";
  const isOutdoor = company && company.Name && company.Name.toLowerCase() == "outdoor";


  const navigate = useNavigate();

  useEffect(() => {
    if (selectedSeries) {
      setSelectedSeries(selectedSeries);
      setDataItem({ ...dataItem, Series_Id: selectedSeries._id })
    }
    loadcombo();
    if (dataItem.SID > 0) {
      loadEditData();
    }
  }, []);

  useEffect(() => {
    setShowSeasonOverview(dataItem.SID == 0 ? true : false);
  }, [dataItem.SID]);

  const loadcombo = async () => {
    // let mediaCategory = await API.getDataLookup(ENTITYNAME.MediaCategory, { sort: { Description: 1 } });
    // setMediaCategory(mediaCategory.data);
    let content = await API.getDataLookup(ENTITYNAME.Content, { sort: { Description: 1 }, query: ['Archive', '=', false] });
    let filteredEpisodeContent = content.data.filter((item) => item.MediaCategoryType.MediaCategorySID == MEDIACATEGORIES.Episode || item.MediaCategoryType.MediaCategorySID == 0);
    let filteredSeasonContent = content.data.filter((item) => item.MediaCategoryType.MediaCategorySID == MEDIACATEGORIES.Season)
    setEpisodeContent(filteredEpisodeContent);
    // setEpisodeContent(content.data);
    setContent(filteredSeasonContent);
    let genresRes = await API.getDataLookup(ENTITYNAME.Genre, { sort: { Description: 1 } });
    setGenres(genresRes.data);

    let providerRes = await API.getDataLookup(ENTITYNAME.OttProvider, { sort: { Description: 1 } });
    setProviders(providerRes.data);

    let languagesRes = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 } });
    setLanguages(languagesRes.data);

    let transmissionRes = Object.keys(MEDIA_TRANSMISSION).map((x) => ({
      _id: MEDIA_TRANSMISSION[x],
      Description: x
    }));
    setTransmissions(transmissionRes)

    let targetGroupRes = await API.getDataLookup(ENTITYNAME.TargetGroups, { sort: { Name: 1 } });
    setTargetGroups(targetGroupRes.data);

    const countryRes = await API.getDataLookup(ENTITYNAME.CountryCode, { sort: { Description: 1 } });
    setCountries(countryRes.data);

    let platformRes = await API.getDataLookup(ENTITYNAME.Platform, { sort: { Description: 1 } });
    setPlatforms(platformRes.data);

    let channelRes = await API.getValidChannels(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
    setChannels(channelRes.data);

    let pgRatingRes = await API.getDataLookup(ENTITYNAME.PGRating, { sort: { Description: 1 } });
    setPgRatings(pgRatingRes.data);

    let userChannels = await utility.getUserChannels()
    setCurrentUserChannels(userChannels);

    if ((dataItem.SID == 0 && !props?.isFromAddProgram)) {

      if (filteredSeasonContent.length > 0) {

        setDataItem({
          ...dataItem,
          Genres: utility.getDefaultItems(genresRes.data),
          SubGenres: utility.getDefaultItems(genresRes.data),
          MediaType: { _id: dataItem.MediaType._id, SID: dataItem.MediaType.SID, Description: dataItem.MediaType.Description },
          MediaSubType: { _id: dataItem.MediaSubType._id, SID: dataItem.MediaSubType.SID, Description: dataItem.MediaSubType.Description },
          AssetId: await DataHelper.getNewAssetId(filteredSeasonContent[0]),
          Content: filteredSeasonContent.length > 0 ? filteredSeasonContent[0] : {},
          Series_Id: selectedSeries ? selectedSeries._id : "",
          Channels: channelRes.data && channelRes.data.length == 1 ? channelRes.data : [],
        })
        console.log(dataItem);
      }

      setCreateEpisodeDataItem({
        NumberOfEpisodes: 1,
        Content: filteredEpisodeContent.length > 0 ? filteredEpisodeContent[0] : {},
        StartingEpisodes: 1,
        Duration: "00:00:00:00",
      })

    }

  }

  const onChange = async (e) => {
    let updatedItem = { ...dataItem };

    if (e.target.name == "Content") {
      updatedItem.Content = e.target.value;

      const updatedContent = await API.getAndSaveNextNumber(
        e.target.value.SID,
        { ...e.target.value, isSaveNextnumber: false }
      );

      if (!updatedContent.success) return;

      updatedItem.AssetId = updatedContent.data.HouseNumber;

    } else if (e.target.name == "Title") {

      updatedItem.Title = e.target.value;
      dataItem?.SID == 0 && (updatedItem.Description = e.target.value);

    } else if (e.target.name == "Foreground" || e.target.name == "Background") {

      updatedItem.Colors = {
        ...dataItem.Colors,
        [e.target.name]: e.target.value
      };

    } else if (e.target.name == "CustomTitle1" || e.target.name == "CustomTitle2") {

      let name = e.target.name == "CustomTitle1" ? "Title1" : "Title2";

      updatedItem.CustomTitle = {
        ...dataItem.CustomTitle,
        [name]: e.target.value
      };

    } else if (e.target.name === "isAllChannels") {

      const newValue = !selectAllChannels;

      setSelectAllChannels(newValue);

      updatedItem.Channels = newValue ? channels : [];

    } else if (e.target.name === "Channels") {

      updatedItem.Channels = e.target.value;

      if (e.target.value.length === channels.length) {
        setSelectAllChannels(true);
      } else {
        setSelectAllChannels(false);
      }

    } else if (e.target.name === "isAllPlatforms") {

      const newValue = !selectAllPlatforms;

      setSelectAllPlatforms(newValue);

      updatedItem.Platforms = newValue ? platforms : [];

    } else if (e.target.name === "Platforms") {

      updatedItem.Platforms = e.target.value;

      if (e.target.value.length === platforms.length) {
        setSelectAllPlatforms(true);
      } else {
        setSelectAllPlatforms(false);
      }

    } else {

      updatedItem[e.target.name] = e.target.value;

    }

    // update working title when related fields change
    if (["Title", "CustomTitle2", "SeasonNumber", "PGRating", "DealReference"].includes(e.target.name)
    ) {
      updatedItem.WorkingTitle = DataHelper.getWorkingTitle({
        customTitle2: updatedItem.CustomTitle?.Title2,
        title: updatedItem.Title,
        seasonNumber: updatedItem.SeasonNumber,
        pgRating: updatedItem.PGRating?.Description,
        dealReference: updatedItem.DealReference
      });
    }

    setDataItem(updatedItem);

    if (e.target.name == "Archive") {
      setIsArchiveChanged(!isArchiveChanged);
    }
  };

  const onDropdownFilterChange = (e, fieldName) => {
    setDropdownFilters((prev) => ({
      ...prev,
      [fieldName]: e.filter?.value || ''
    }));
  };

  const getFilteredDropdownData = (data = [], fieldName) => {
    const filterValue = (dropdownFilters[fieldName] || '').toLowerCase();
    if (!filterValue) return data;
    return data.filter((item) => (item?.Description || '').toLowerCase().includes(filterValue));
  };

  const handleTMDBSeasonSelect = async (showDetails, seasonDetails, episodesList) => {
    try {
      console.log("Selected TMDB Season:", seasonDetails, "for show:", showDetails);

      let tmdbGenres = showDetails.Genres ? showDetails.Genres.split(',').map(x => x.trim()).filter(Boolean) : [];
      let resolvedGenres = [];
      for (let i = 0; i < tmdbGenres.length; i++) {
        let item = tmdbGenres[i];
        let localGenre = genres.find(g => g?.Description?.toLowerCase() === item.toLowerCase());
        if (localGenre) {
          resolvedGenres.push(localGenre);
        } else {
          let newGenreRes = await API.saveData(ENTITYNAME.Genre, {
            Description: item,
            Archive: false,
            Code: item,
            ExternalDescription: item,
            AlternateDescription: item
          });
          if (newGenreRes.success) {
            resolvedGenres.push(newGenreRes.data);
            setGenres(prev => [...prev, newGenreRes.data]);
          }
        }
      }

      const seasonTitle = `${showDetails.Title} S-${seasonDetails.season_number}`;
      const seasonDesc = seasonDetails.overview || showDetails.Overview;
      const seasonYear = seasonDetails.air_date ? new Date(seasonDetails.air_date).getFullYear() : showDetails.Year;
      const seasonImage = seasonDetails.poster_path || showDetails.Poster;

      let prepareData = {
        Title: seasonTitle,
        Description: seasonDesc,
        Synopsis: seasonDesc,
        ProductionYear: seasonYear,
        ImageUrl: seasonImage,
        Genres: resolvedGenres,
        SubGenres: resolvedGenres,
        SeasonNumber: seasonDetails.season_number,
        WorkingTitle: seasonTitle
      };

      if (seasonImage) {
        setSelectedImageUrl(seasonImage);
      }
      setDataItem({ ...dataItem, ...prepareData });

      const defaultEpisodeContent = episodeContent?.length > 0 ? episodeContent[0] : {};

      let avgRuntime = 30;
      if (episodesList && episodesList.length > 0) {
        let runtimes = episodesList.map(ep => ep.runtime).filter(Boolean);
        if (runtimes.length > 0) {
          avgRuntime = runtimes[0];
        }
      }
      const hours = Math.floor(avgRuntime / 60);
      const minutes = avgRuntime % 60;
      const formattedDuration = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00:00`;

      setCreateEpisodeDataItem({
        ...createEpisodeDataItem,
        StartingEpisodes: 1,
        NumberOfEpisodes: seasonDetails.episode_count || episodesList.length || 1,
        Duration: formattedDuration,
        Content: defaultEpisodeContent,
        EpisodesList: episodesList || []
      });

      setFormOpen(true);
      setOpenTMDB(false);
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `Loaded TMDB Season details successfully!` });
    } catch (err) {
      console.error("Error in handleTMDBSeasonSelect:", err);
      ToastNotification({ type: TOAST_TYPES.ERROR, title: "Error mapping season metadata", message: err.message });
    }
  };

  const handleCreateEpisodeChange = (e) => {
    setCreateEpisodeDataItem({ ...createEpisodeDataItem, [e.target.name]: e.target.value });

    if (e.target.name == "NumberOfEpisodes") {
      if (e.target.value > 0) {
        setDisableEpsiodeFields(() => false);
      } else {
        setDisableEpsiodeFields(() => true);
      }
    }
  };

  const loadEditData = async () => {
    setSelectedImageUrl(dataItem.ImageUrl);
    if (dataItem.Series_Id == undefined || dataItem.Series_Id.length == 0) return;
  };

  const setSelectedImage = (dataList) => {
    setSelectedImageUrl(() => dataList[0].ImageUrl);
    setDataItem({ ...dataItem, ["ImageUrl"]: dataList[0].ImageUrl });
  }

  const onSelectionSeries = (dataList) => {
    // setSeries(() => dataList[0]);

    console.log(dataList);
    setSelectedSeries(() => dataList[0]);
    setDataItem({ ...dataItem, ["Series_Id"]: dataList[0]._id });
  }

  const onCancelEdit = () => {
    if (dataItem.SID == 0) {

      if (location.state.selectedSeries) {
        history.replace(`/home/MediaEpisode/Series/${location.state.selectedSeries.SID}`, { state: { quickEdit: false, copy: false } })
        navigate(-1);
      } else {
        navigate(-1);
      }

      setFormOpen(false);
    } else if (props.isManageContent) {
      props.onCancelEdit();
    } else {
      props.quickEdit ? navigate(-1) : setFormOpen(false);
    }
  }

  const isValid = async () => {

    if (dataItem.Title == '' || dataItem.Title == undefined) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_title_error_message });
      return false;
    }

    if (dataItem.SeasonNumber < 1 || dataItem.SeasonNumber == undefined) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.season_number_should_not_be_zero_error_message });
      return false;
    }

    //Already existing season of selected series
    if (dataItem.SID == 0 && selectedSeries.SID != undefined) {
      let temp = [];
      if (props.existingSeasons != undefined) {
        temp = props.existingSeasons.map((x) => x.SeasonNumber.replace('Season: ', ''))
      } else {
        //fetch
        let existingSeasons = await API.getData(ENTITYNAME.Season, { query: ['Series_Id', '=', selectedSeries._id] });
        temp = existingSeasons.data.map((x) => x.SeasonNumber)
      }
      let checkSeasonNumber = temp.some((x) => parseInt(x) == dataItem.SeasonNumber);
      if (checkSeasonNumber) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Season Number is already exists in Selected Parent Series, Please Select correct Parent Series" });
        return false;
      }

    }

    if (dataItem.Genres == undefined || dataItem.Genres.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_genre_error_message });
      return false;
    }

    if (dataItem.SID == 0 && Object.keys(dataItem.Content).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_content_error_message });
      return false;
    }
    if (dataItem.Description == '' || dataItem.Description == undefined) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_description_error_message });
      return false;
    }

    if (dataItem.SID == 0) {
      if (Object.keys(createEpisodeDataItem.Content).length == 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_episode_content_error_message });
        return false;
      }

      if (createEpisodeDataItem.Content.Custom == CONTENT_CUSTOM_ENUM.ETISALAT_TIT_Y_SN_EP_LNG && (dataItem.Languages || []).length === 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_language_error_message });
        return false;
      }

      if (createEpisodeDataItem.Content.Custom == CONTENT_CUSTOM_ENUM.ECITY_LC_Y_TSN_CNC_PC_EP && (!dataItem.Country || Object.keys(dataItem.Country).length === 0)) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_country_error_message });
        return false;
      }

      if (createEpisodeDataItem.Content.Custom == CONTENT_CUSTOM_ENUM.ECITY_LC_Y_TSN_CNC_PC_EP && (!dataItem.MediaType || Object.keys(dataItem.MediaType).length === 0)) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_country_error_message });
        return false;
      }

      if (createEpisodeDataItem.Content.Custom == CONTENT_CUSTOM_ENUM.ETISALAT_TIT_Y_SN_EP_LNG && (dataItem.ProductionYear == undefined || dataItem.ProductionYear === "")) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_production_year_error_message });
        return false;
      }


      if (createEpisodeDataItem.NumberOfEpisodes < 1 || createEpisodeDataItem.NumberOfEpisodes == undefined) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.number_of_epiosde_should_not_be_zero_error_message });
        return false;
      }
      if (createEpisodeDataItem.StartingEpisodes < 1 || createEpisodeDataItem.StartingEpisodes == undefined) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.starting_epiosde_should_not_be_zero_error_message });
        return false;
      }
      if (createEpisodeDataItem.Duration.includes("_") || createEpisodeDataItem.Duration == '00:00:00:00') {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.invalid_duration_error_message });
        return false;
      }
    }

    if (dataItem.SID == 0) {
      if (!dataItem?.Channels || dataItem.Channels.length === 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_linear_channels_error_message });
        return false;
      }

      if (!dataItem?.isLinearUnlimitedRights) {
        if (!dataItem?.LinearStartDate || dataItem?.LinearStartDate == "") {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_linear_start_date_error_message });
          return false;
        }

        if (!dataItem?.LinearEndDate || dataItem?.LinearEndDate == "") {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_linear_end_date_error_message });
          return false;
        }

        if (dataItem.LinearStartDate > dataItem.LinearEndDate) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.linear_start_and_end_date_error_message });
          return false;
        }
      }

      if (!dataItem?.isNonLinearUnlimitedRights) {
        if (!dataItem?.NonLinearStartDate || dataItem?.NonLinearStartDate == "") {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_non_linear_start_date_error_message });
          return false;
        }

        if (!dataItem?.NonLinearEndDate || dataItem?.NonLinearEndDate == "") {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_non_linear_end_date_error_message });
          return false;
        }

        if (dataItem.NonLinearStartDate > dataItem.NonLinearEndDate) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.non_linear_start_and_end_date_error_message });
          return false;
        }
      }
    }

    return true;
  }

  const onSaveData = async () => {

    const isValidCheck = await isValid();

    if (!isValidCheck) {
      return;
    }

    if (props.quickEdit) {
      props.onSave();
      onCancelEdit();
    } else if (props.isManageContent) {
      props.onSave();
      props.onCancelEdit();
    } else {
      setFormOpen(false);
    }
  };

  const onCreateMasterClick = (key) => {
    setShowEditForm({
      ...defaultFormState,
      [key]: true
    });
  }

  const handleLangugaeTranslate = (data) => {
    setDataItem({ ...dataItem, Synopsis: data });
    setShowTranslateForm(false);
  }

  const updateReferenceCode = async () => {
    let updateReferenceCode = {
      season_id: dataItem._id,
      SeasonCode: dataItem?.SeasonCode ?? ""
    }
    await API.updateEpisodeReferenceCode(updateReferenceCode);
    props.loadEpisodes(dataItem._id, false);
  }

  const confirAlertUpdateReferenceCode = async () => {
    ConfirmAlert(
      () => { updateReferenceCode() },
      () => { },
      lang.sync_reference_code_message,
      'Are you sure you want to update ?'
    );
  };
  const onBossAIMetaDataLoad = async (item) => {
    let aiDataRes = await utility.loadDataViaBOSS_AI(BA_ACTION.Thumbnail, item, dataItem);
    console.log(aiDataRes);
    return aiDataRes;
  }

  const setImageUrl = (data) => {
    if (data && data.success && data.imageUrl) {
      setSelectedImageUrl(data.imageUrl);
      setDataItem({ ...dataItem, ImageUrl: data.imageUrl });
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: data.message });
    }
  }

  const style = {
    labelStyel: { fontSize: '11px', fontWeight: 600, color: '#444', marginBottom: '3px', display: 'block' },
    sectionCard: { marginBottom: '16px', padding: '12px 14px', background: '#f5f5f5', borderRadius: '8px', border: '1px solid #e2e2e2' },
    sectionHeader: { fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: '#3A3633', marginBottom: '10px', paddingLeft: '8px', borderLeft: '3px solid #3A3633' },
  }

  return (
    <div className="mb-3 ml-2 mt-3" style={{ maxWidth: "70vw" }}>
      <MediaHeroCard
        imageUrl={dataItem?.ImageUrl}
        title={dataItem?.Title ? utility.subString(dataItem?.Title, 36) : lang.enter_title}
        assetId={dataItem?.AssetId}
        badges={[
          dataItem?.PGRating?.Description,
          (dataItem?.Genres || []).map((obj) => obj?.Description).filter(Boolean).join(' | '),
          (dataItem?.Languages || []).map((obj) => obj?.Description).filter(Boolean).join(' | '),
        ].filter(Boolean)}
        summary={dataItem?.Description ? utility.subString(dataItem?.Description, 150) : ""}
        facts={[
          { label: lang.asset_id_label, value: `#${dataItem?.AssetId}` },
          { label: lang.series_label, value: selectedSeries?.Title },
          { label: lang.season_no_label ?? "Season No", value: dataItem?.SeasonNumber },
          { label: lang.episodes_label ?? "Episodes", value: dataItem?.NumberOfEpisodes },
          { label: lang.pg_rating_label ?? "PG Rating", value: dataItem?.PGRating?.Description },
          { label: lang.genre_label, value: (dataItem?.Genres || []).map((obj) => obj?.Description).filter(Boolean).join(' | ') },
          { label: lang.languages_label ?? "Languages", value: (dataItem?.Languages || []).map((obj) => obj?.Description).filter(Boolean).join(' | ') },
          { label: lang.description_label, value: dataItem?.Description ? utility.subString(dataItem?.Description, 150) : "" },
        ]}
        expanded={showSeasonOverview}
        onToggleExpanded={() => setShowSeasonOverview((prev) => !prev)}
        actions={[
          dataItem.SID > 0
            ? {
              title: "Settings",
              icon: "fa-solid fa-gear",
              onClick: () => setOpenMediaEpisodeSettingForm(true),
            }
            : null,
          {
            title: lang.edit_button_tooltip ?? "Edit",
            icon: "fa-solid fa-pen-to-square",
            onClick: () => setFormOpen(true),
          },
        ].filter(Boolean)}
      />
      {openForm && <BossDialog
        title={dataItem?.SID > 0 ? dataItem?.Title : `${lang.create_season_dialog_header}`}
        onClose={onCancelEdit}
        width={"70%"}
        height={dataItem?.SID > 0 ? "" : "84%"}
      >
        <div className="row mt-2 mb-2">
          <div className="marlr">
            <SaveButton title={lang.confirm_button} tooltip={lang.confirm_button_tooltip} onClick={() => onSaveData()}></SaveButton>
            <CancelButton onClick={onCancelEdit}></CancelButton>
          </div>
        </div>

        <Form
          render={(formRenderProps) => (
            <FormElement>
              <div style={{ display: 'flex', gap: '20px' }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={style.sectionCard}>
                    <div style={style.sectionHeader}>{lang.title_and_description_section_header}</div>
                    <div className="row" style={{ marginBottom: '8px' }}>
                      <div className="col-6">
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '3px' }}>
                          <label style={{ ...style.labelStyel, marginBottom: 0 }}>{lang.title_label} *</label>
                          {dataItem.SID == 0 && (
                            <span
                              className="badge"
                              style={{
                                backgroundColor: '#01b4e4',
                                color: 'white',
                                cursor: 'pointer',
                                padding: '2px 6px',
                                fontSize: '10px',
                                fontWeight: 'bold',
                                borderRadius: '4px',
                                textTransform: 'uppercase'
                              }}
                              onClick={() => setOpenTMDB(true)}
                            >
                              TMDB
                            </span>
                          )}
                        </div>
                        <input name="Title" type="text" className="form-control form-control-sm" value={dataItem.Title} onChange={(e) => onChange(e)} />
                      </div>
                      <div className="col-3">
                        <label style={style.labelStyel}>{lang.custom_title_1_label}</label>
                        <input name="CustomTitle1" type="text" className="form-control form-control-sm" value={dataItem?.CustomTitle?.Title1} onChange={onChange} />
                      </div>
                      <div className="col-3">
                        <label style={style.labelStyel}>{lang.custom_title_2_label}</label>
                        <input name="CustomTitle2" type="text" className="form-control form-control-sm" value={dataItem?.CustomTitle?.Title2} onChange={onChange} />
                      </div>
                    </div>
                    <div className="row" style={{ marginBottom: '8px' }}>
                      <div className="col-2">
                        <label style={style.labelStyel}>{lang.season_number_label}</label>
                        <input name="SeasonNumber" type="number" className="form-control form-control-sm" value={dataItem.SeasonNumber} onChange={(e) => onChange(e)} />
                      </div>
                      <div className="col-4">
                        <label style={style.labelStyel}>{lang.transmission_label}</label>
                        <DropDownList
                          style={{ backgroundColor: "white" }}
                          data={transmissions}
                          textField='Description'
                          dataItemKey='_id'
                          name="Transmission"
                          value={dataItem.Transmission}
                          onChange={onChange}
                        />
                      </div>
                      <div className="col-3">
                        <label style={style.labelStyel}>{lang.short_title_label}</label>
                        <input name="ShortTitle" type="text" className="form-control form-control-sm" value={dataItem?.ShortTitle} onChange={onChange} />
                      </div>
                      <div className="col-3">
                        <label style={style.labelStyel}>{lang.custom_short_title_label}</label>
                        <input name="CustomShortTitle" type="text" className="form-control form-control-sm" value={dataItem?.CustomShortTitle} onChange={onChange} />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '3px' }}>
                          <label style={{ ...style.labelStyel, marginBottom: 0 }}>{lang.description_label} *</label>
                          {isEncompass && <i className="fa-solid fa-language cursor-pointer" aria-hidden="true" title={lang.translate_synopsis_level} onClick={() => setShowTranslateForm(true)} style={{ color: '#888', fontSize: '14px' }}></i>}
                        </div>
                        <textarea rows={2} type="text" className="form-control form-control-sm" name="Description" value={dataItem.Description} onChange={onChange} />
                      </div>
                      <div className="col-6">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '3px' }}>
                          <label style={{ ...style.labelStyel, marginBottom: 0 }}>{lang.custom_description_label}</label>
                        </div>
                        <textarea rows={2} type="text" className="form-control form-control-sm" name="CustomDescription" value={dataItem.CustomDescription} onChange={onChange} />
                      </div>
                    </div>
                  </div>

                  <div style={style.sectionCard}>
                    <div style={style.sectionHeader}>{lang.content_and_identification_section_header}</div>
                    <div className='row'>
                      <div className="col-3">
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '3px' }}>
                          <label style={{ ...style.labelStyel, marginBottom: 0 }}>{lang.content_label} *</label>
                          <TooltipInfoCard message={lang.used_to_configure_prefix_suffix_and_incremental_next_number_for_assetid_tooltip} />
                        </div>
                        <div style={{ display: 'flex', gap: '6px' }}>
                          <DropDownList
                            data={content}
                            name="Content"
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.Content}
                            onChange={onChange}
                            disabled={dataItem.SID > 0 ? true : false}
                          />
                          <button type="button" title={lang.create_content_button_tooltip} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                            style={{ height: "35px", minWidth: '35px', padding: '0 6px', flexShrink: 0 }} onClick={() => { onCreateMasterClick('Content') }}><i className="fa-solid fa-plus fa-xs"></i>
                          </button>
                        </div>
                      </div>
                      <div className="col-3">
                        <label style={style.labelStyel}>{lang.provider_label}</label>
                        <DropDownList
                          style={{ backgroundColor: "white" }}
                          data={providers}
                          name="Provider"
                          textField="Description"
                          dataItemKey="_id"
                          value={dataItem.Provider}
                          onChange={onChange}
                        />
                      </div>
                      <div className="col-3">
                        <label style={style.labelStyel}>{lang.asset_id_label}</label>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: '3px' }}>
                          {dataItem.SID == 0 && <div style={{ display: "flex", alignItems: "center" }}>
                            <Field
                              name="isManualAssetId"
                              component={Checkbox}
                              onChange={async (e) => {
                                if (!e.target.value) {
                                  setDataItem({
                                    ...dataItem,
                                    AssetId: await DataHelper.getNewAssetId(dataItem.Content),
                                  });
                                }
                                props.setIsManualAssetId(e.target.value);
                              }}
                              checked={props.isManualAssetId}
                              style={{ marginRight: "5px", borderColor: "black" }}
                            />
                            <label htmlFor="isManualAssetId" style={{ cursor: "pointer", fontSize: "10px", marginBottom: 0 }}>{lang.manual_label}</label>
                          </div>}
                        </div>
                        {props.isManualAssetId ? (
                          <input type="text" className="form-control form-control-sm" name="AssetId" value={dataItem.AssetId} onChange={(e) => onChange(e)} />
                        ) : (
                          <h3 style={{ marginTop: '2px' }}>{dataItem.AssetId}</h3>
                        )}
                      </div>
                      <div className="col-3">
                        <label style={style.labelStyel}>{lang.series_code_label}</label>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <input name="SeasonCode" type="text" className="form-control form-control-sm" value={dataItem.SeasonCode} onChange={(e) => onChange(e)} />
                          {dataItem.SID > 0 && dataItem?.SeasonCode?.length > 0 && <RoundButton title={lang.sync_reference_code_message} icon="refresh" onClick={confirAlertUpdateReferenceCode} />}
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

                <div style={{ width: '250px', flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <div style={{ ...style.sectionCard, width: '100%', marginBottom: 0 }}>
                    <div style={{ display: 'flex', gap: '8px', marginBottom: '8px', alignItems: 'center', justifyContent: 'center' }}>
                      <i className="fa fa-pencil" title="Edit Image Url" style={{ cursor: 'pointer', fontSize: '13px', color: '#666', padding: '5px', borderRadius: '4px', background: '#eee' }} onClick={() => setOpenImageInput(true)}></i>
                      <i className="fa fa-file-text" title='Select Image' style={{ cursor: 'pointer', fontSize: '13px', color: '#666', padding: '5px', borderRadius: '4px', background: '#eee' }} onClick={() => setOpenImageBank(true)}></i>
                      <i className="fa fa-magnifying-glass" title="Browse Image" style={{ cursor: 'pointer', fontSize: '13px', color: '#666', padding: '5px', borderRadius: '4px', background: '#eee' }} onClick={() => setOpenImageBrowse(true)}></i>
                      <BossAssistantIcon
                        style={{}}
                        mediaEpisodeEntity={dataItem}
                        iconSize={"22px"}
                        onDataLoad={onBossAIMetaDataLoad}
                        popupTtle={"Generate Thumbnail with Boss AI"}
                        tooltip={"Generate Thumbnail with Boss AI"}
                        description={"BOSS AI Generating Thumbnail"}
                        setMetaData={setImageUrl}
                      />
                    </div>
                    <div style={{ width: '220px', height: '320px', overflow: 'hidden', borderRadius: '8px', boxShadow: '0 1px 8px rgba(0,0,0,0.25)', background: '#fff' }}>
                      <ImageCard style={{ width: '100%', height: '100%', objectFit: 'cover' }} width={"100%"} height={"100%"} img={dataItem.ImageUrl} alt='Dummy' />
                    </div>
                  </div>
                </div>
              </div>

              <div style={style.sectionCard}>
                <div style={style.sectionHeader}>{lang.timing_and_classification_section_header}</div>
                <div className='row'>
                  <div className="col-3">
                    <label style={style.labelStyel}>{lang.genre_label} *</label>
                    <div style={{ display: 'flex', gap: '6px' }}>
                      <MultiSelect
                        data={getFilteredDropdownData(genres, 'Genres')}
                        name={"Genres"}
                        textField="Description"
                        dataItemKey="_id"
                        value={dataItem.Genres}
                        onChange={onChange}
                        filterable={true}
                        onFilterChange={(e) => onDropdownFilterChange(e, 'Genres')}
                      />
                      <button type="button" title={lang.create_genre_button_tooltip} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                        style={{ height: "35px", minWidth: '35px', padding: '0 6px', flexShrink: 0 }} onClick={() => { onCreateMasterClick('Genre') }}><i className="fa-solid fa-plus fa-xs"></i>
                      </button>
                    </div>
                  </div>
                  <div className="col-3">
                    <label style={style.labelStyel}>{lang.sub_genre_label}</label>
                    <div style={{ display: 'flex', gap: '6px' }}>
                      <MultiSelect
                        data={getFilteredDropdownData(genres, 'SubGenres')}
                        name={"SubGenres"}
                        textField="Description"
                        dataItemKey="_id"
                        value={dataItem.SubGenres}
                        onChange={onChange}
                        filterable={true}
                        onFilterChange={(e) => onDropdownFilterChange(e, 'SubGenres')}
                      />
                      <button type="button" title={lang.create_sub_genre_button_tooltip} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                        style={{ height: "35px", minWidth: '35px', padding: '0 6px', flexShrink: 0 }} onClick={() => { onCreateMasterClick('Genre') }}><i className="fa-solid fa-plus fa-xs"></i>
                      </button>
                    </div>
                  </div>
                  {createEpisodeDataItem.Content?.Custom === CONTENT_CUSTOM_ENUM.ECITY_LC_Y_TSN_CNC_PC_EP ? (
                    <div className="col-3">
                      <label style={style.labelStyel}>{`${lang.country_label} *`}</label>
                      <DropDownList
                        data={countries}
                        name="Country"
                        textField="Description"
                        dataItemKey="_id"
                        value={dataItem.Country}
                        onChange={(e) => onChange(e)}
                      />
                    </div>
                  ) : (
                    <div className="col-3">
                      <label style={style.labelStyel}>{`${lang.language_label} ${createEpisodeDataItem.Content && createEpisodeDataItem.Content.Custom && createEpisodeDataItem.Content.Custom == CONTENT_CUSTOM_ENUM.ETISALAT_TIT_Y_SN_EP_LNG ? "*" : ""}`}</label>
                      <MultiSelect
                        data={getFilteredDropdownData(languages, 'Languages')}
                        name="Languages"
                        textField="Description"
                        dataItemKey="_id"
                        value={dataItem.Languages}
                        onChange={onChange}
                        filterable={true}
                        onFilterChange={(e) => onDropdownFilterChange(e, 'Languages')}
                      />
                    </div>
                  )}
                  <div className="col-3">
                    <label style={style.labelStyel}>{lang.dubbed_languages_label}</label>
                    <MultiSelect
                      data={getFilteredDropdownData(languages, 'DubbedLanguages')}
                      name="DubbedLanguages"
                      textField="Description"
                      dataItemKey="_id"
                      value={dataItem.DubbedLanguages}
                      onChange={onChange}
                      filterable={true}
                      onFilterChange={(e) => onDropdownFilterChange(e, 'DubbedLanguages')}
                    />
                  </div>
                </div>
                <div className='row' style={{ marginTop: '10px' }}>
                  <div className="col-3">
                    <label style={style.labelStyel}>{`${lang.production_year_label} ${createEpisodeDataItem.Content && createEpisodeDataItem.Content.Custom && createEpisodeDataItem.Content.Custom == CONTENT_CUSTOM_ENUM.ETISALAT_TIT_Y_SN_EP_LNG ? "*" : ""}`}</label>
                    <input name="ProductionYear" type="text" className="form-control form-control-sm" value={dataItem.ProductionYear} onChange={(e) => onChange(e)} />
                  </div>
                  {/* <div className="col-3">
                    <label style={style.labelStyel}>{lang.target_group_label}</label>
                    <DropDownList
                      style={{ backgroundColor: "white" }}
                      data={targetGroups}
                      textField='Name'
                      dataItemKey='_id'
                      className="form-control form-control-sm"
                      name="TargetGroup"
                      value={dataItem.TargetGroup}
                      onChange={(e) => onChange(e)}
                    />
                  </div> */}
                  <div className="col-3">
                    <label style={style.labelStyel}>{lang.pg_rating_label}</label>
                    <DropDownList
                      data={pgRatings}
                      name="PGRating"
                      textField="Description"
                      dataItemKey="_id"
                      value={dataItem.PGRating}
                      onChange={onChange}
                    />
                  </div>
                  <div className="col-3">
                    <label style={style.labelStyel}>{`${lang.media_type_label}${createEpisodeDataItem.Content && createEpisodeDataItem.Content.Custom && createEpisodeDataItem?.Content?.Custom === CONTENT_CUSTOM_ENUM.ECITY_LC_Y_TSN_CNC_PC_EP ? " *" : ''}`}</label>
                    <DropDownList
                      data={genres}
                      name={"MediaType"}
                      textField="Description"
                      dataItemKey="_id"
                      value={dataItem.MediaType}
                      onChange={onChange}
                    />
                  </div>
                  <div className="col-3">
                    <label style={style.labelStyel}>{lang.media_sub_type_label}</label>
                    <DropDownList
                      data={genres}
                      name={"MediaSubType"}
                      textField="Description"
                      dataItemKey="_id"
                      value={dataItem.MediaSubType}
                      onChange={onChange}
                    />
                  </div>
                  <div className="col-3 mt-2">
                    <label style={style.labelStyel}>{lang.deal_reference_label}</label>
                    <input name="DealReference" type="text" className="form-control form-control-sm" value={dataItem.DealReference} onChange={(e) => onChange(e)} />
                  </div>
                  <div className="col-6 mt-2">
                    <label style={style.labelStyel}>{lang.working_title_label}</label>
                    <input name="WorkingTitle" type="text" className="form-control form-control-sm" value={dataItem.WorkingTitle} onChange={(e) => onChange(e)} disabled />
                  </div>
                  <div className="col-3 mt-2">
                    <label style={style.labelStyel}>{lang.series_label}</label>
                    <div style={{ display: "flex", gap: '6px' }}>
                      <input name="Description" type="text" className="d-inline form-control form-control-sm" value={selectedSeries?.Title} onChange={(e) => onChange(e)} disabled={dataItem.SID > 0 ? true : props.disableSelectSeries} />
                      <button type="button" title='Create Content' className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                        style={{ height: "32px", minWidth: '30px', fontSize: '12px', fontWeight: 600 }} onClick={() => { setOpenSeriesSelection(true) }} disabled={dataItem.SID > 0 ? true : props.disableSelectSeries}>
                        <i className="fa-solid fa-ellipsis-vertical fa-s"></i>
                      </button>
                      <button type="button" title='Create Content' className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                        style={{ height: "32px", minWidth: '30px', }} onClick={() => { setSelectedSeries({ Title: '' }) }} disabled={dataItem.SID > 0 ? true : props.disableSelectSeries}>
                        <i className="fa-solid fa-times fa-xs"></i>
                      </button>
                    </div>
                  </div>
                </div>
                {(isEncompass || isOutdoor) && <div style={{ marginTop: '10px' }}>
                  <label style={style.labelStyel}>{lang.synopsis_label}</label>
                  <textarea type="text" className="form-control form-control-sm" name="Synopsis" value={dataItem.Synopsis} onChange={(e) => onChange(e)} />
                </div>}
                <div style={{ display: 'flex', alignItems: 'center', gap: '18px', flexWrap: 'wrap', marginTop: '10px' }}>
                  <Field
                    style={{ borderColor: "black" }}
                    name={"IsLive"}
                    component={Checkbox}
                    label={lang.islive_label}
                    onChange={(e) => onChange(e)}
                    checked={dataItem.IsLive ? true : false}
                  />
                  <Field
                    style={{ borderColor: "black" }}
                    name={"IsCatchUp"}
                    component={Checkbox}
                    label={lang.is_catch_up_label}
                    onChange={(e) => onChange(e)}
                    checked={dataItem.IsCatchUp ? true : false}
                  />
                  <Field
                    style={{ borderColor: "black" }}
                    name={"Archive"}
                    component={Checkbox}
                    label={lang.archive}
                    onChange={(e) => onChange(e)}
                    checked={dataItem.Archive ? true : false}
                  />
                </div>
              </div>

              {dataItem.SID == 0 && (<div className='row'>
                <div className='col-6'>
                  <div style={style.sectionCard}>
                    <div style={style.sectionHeader}>{lang.linear_deal_rights_label}</div>
                    <div className='row'>
                      <div className="col-12 mb-2">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <label style={style.labelStyel} className="mb-0 fw-semibold"> {lang.linear_channels_label}<span className="text-danger">*</span></label>
                          <div className="d-flex align-items-end">
                            <div>
                              <input
                                type="checkbox"
                                name="isLinearUnlimitedRights"
                                className="ml-1"
                                checked={dataItem?.isLinearUnlimitedRights}
                                onChange={() =>
                                  setDataItem({
                                    ...dataItem,
                                    isLinearUnlimitedRights: !dataItem?.isLinearUnlimitedRights
                                  })
                                }
                              />
                              <span className="ml-1">{lang.is_unlimited_label}</span>
                            </div>
                            <div className='ml-1'>
                              <input
                                type="checkbox"
                                name="isAllChannels"
                                className="ml-1"
                                value={selectAllChannels}
                                checked={selectAllChannels}
                                onChange={onChange}
                              />
                              <span className="ml-1">{lang.select_all_label}</span>
                            </div>
                          </div>
                        </div>
                        <MyMultiSelect
                          data={channels}
                          name="Channels"
                          textField="FullChannelName"
                          dataItemKey="_id"
                          value={dataItem.Channels}
                          onChange={onChange}
                        />
                      </div>
                      {!dataItem?.isLinearUnlimitedRights ? <>
                        <div className="col-6">
                          <label style={style.labelStyel}>{lang.start_date_label} *</label>
                          <input
                            type="datetime-local"
                            className="form-control form-control-sm"
                            name="LinearStartDate"
                            value={dataItem.LinearStartDate}
                            onChange={onChange}
                          />
                        </div>
                        <div className="col-6">
                          <label style={style.labelStyel}>{lang.end_Date_label} *</label>
                          <input
                            type="datetime-local"
                            className="form-control form-control-sm"
                            name="LinearEndDate"
                            value={dataItem.LinearEndDate}
                            onChange={onChange}
                          />
                        </div>
                      </> :
                        <div className="col-12 mt-1">
                          <small className="text-muted" style={{ fontSize: "11px" }}>
                            Note: Linear Deal Rights validity will default from{" "}
                            <strong>{moment.utc().startOf('day').format('DD/MM/YYYY')}</strong>
                            {" "}to{" "}
                            <strong>{moment.utc().add(50, 'year').endOf('day').format('DD/MM/YYYY')}</strong>
                            {" "}when Unlimited is enabled.
                          </small>
                        </div>}
                    </div>
                  </div>
                </div>

                <div className='col-6'>
                  <div style={style.sectionCard}>
                    <div style={style.sectionHeader}>{lang.non_linear_deal_rights_label}</div>
                    <div className='row'>
                      <div className="col-12 mb-2">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <label style={style.labelStyel} className="mb-0 fw-semibold"> {lang.non_linear_platforms_label}</label>
                          <div className="d-flex align-items-end">
                            <div>
                              <input
                                type="checkbox"
                                name="isNonLinearUnlimitedRights"
                                className="ml-1"
                                checked={dataItem?.isNonLinearUnlimitedRights}
                                onChange={() =>
                                  setDataItem({
                                    ...dataItem,
                                    isNonLinearUnlimitedRights: !dataItem?.isNonLinearUnlimitedRights
                                  })
                                }
                              />
                              <span className="ml-1">{lang.is_unlimited_label}</span>
                            </div>
                            <div className='ml-1'>
                              <input
                                type="checkbox"
                                name="isAllPlatforms"
                                className="ml-1"
                                value={selectAllPlatforms}
                                checked={selectAllPlatforms}
                                onChange={onChange}
                              />
                              <span className="ml-1">{lang.select_all_label}</span>
                            </div>
                          </div>
                        </div>
                        <MyMultiSelect
                          data={platforms}
                          name="Platforms"
                          textField="Description"
                          dataItemKey="_id"
                          value={dataItem.Platforms}
                          onChange={onChange}
                        />
                      </div>
                      {!dataItem?.isNonLinearUnlimitedRights ? <>
                        <div className="col-6">
                          <label style={style.labelStyel}>{lang.start_date_label} *</label>
                          <input
                            type="datetime-local"
                            className="form-control form-control-sm"
                            name="NonLinearStartDate"
                            value={dataItem.NonLinearStartDate}
                            onChange={onChange}
                          />
                        </div>
                        <div className="col-6">
                          <label style={style.labelStyel}>{lang.end_Date_label} *</label>
                          <input
                            type="datetime-local"
                            className="form-control form-control-sm"
                            name="NonLinearEndDate"
                            value={dataItem.NonLinearEndDate}
                            onChange={onChange}
                          />
                        </div>
                      </> :
                        <div className="col-12 mt-1">
                          <small className="text-muted" style={{ fontSize: "11px" }}>
                            Note: Non Linear Deal Rights validity will default from{" "}
                            <strong>{moment.utc().startOf('day').format('DD/MM/YYYY')}</strong>
                            {" "}to{" "}
                            <strong>{moment.utc().add(50, 'year').endOf('day').format('DD/MM/YYYY')}</strong>
                            {" "}when Unlimited is enabled.
                          </small>
                        </div>}
                    </div>
                  </div>
                </div>
              </div>)}

            </FormElement>
          )}
        />

        {dataItem.SID == 0 && <>
          <div style={style.sectionCard}>
            <div style={style.sectionHeader}>{lang.episodes_label}</div>
            <div className="row">

              <div className='col-3'>
                <label style={style.labelStyel}>{lang.starting_episode_label}</label>
                <input name="StartingEpisodes" type="number" className="form-control form-control-sm" value={createEpisodeDataItem.StartingEpisodes} onChange={(e) => handleCreateEpisodeChange(e)} />
              </div>

              <div className="col-3">
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '3px' }}>
                  <label style={{ ...style.labelStyel, marginBottom: 0 }}>{lang.content_label} *</label>
                  <InfoRoundButton message={lang.used_to_configure_prefix_suffix_and_incremental_next_number_for_assetid_tooltip}></InfoRoundButton>
                </div>
                <DropDownList
                  data={episodeContent}
                  name="Content"
                  textField="Description"
                  dataItemKey="_id"
                  value={createEpisodeDataItem.Content}
                  onChange={handleCreateEpisodeChange}
                  validator={(value) => value ? "" : "Please select value"}

                />
              </div>

              <div className='col-3'>
                <label style={style.labelStyel}>{lang.no_of_episodes_label}</label>
                <input name="NumberOfEpisodes" type="number" className="form-control form-control-sm" value={createEpisodeDataItem.NumberOfEpisodes} onChange={(e) => handleCreateEpisodeChange(e)} min={0} />
              </div>

              <div className="col-3">
                <label style={style.labelStyel}>{lang.duration_label} *</label>
                <TimePickerWithFormat
                  className="form-control form-control-sm"
                  name="Duration"
                  value={createEpisodeDataItem.Duration}
                  onChange={(e) => handleCreateEpisodeChange(e)}
                  required
                />
              </div>
            </div>
          </div>
          <p className='text-muted' style={{ fontSize: '11px', position: "relative", top: "5px", left: "15px" }}>{`* ${currentUserChannels && currentUserChannels.length == 1 ? `Deal Rights will automatically be created for ${currentUserChannels[0].FullChannelName}` : "Please create deal rights before saving"}`}</p>
        </>}
      </BossDialog>
      }
      {openImageBank && <CollectionSelection entityname={ENTITYNAME.OttPosters} closeForm={() => setOpenImageBank(!openImageBank)} setDataList={setSelectedImage} title={lang.select_image_collection_header} mode={"single"} width={"50vw"} />}
      {openSeriesSelection && <CollectionSelection entityname={ENTITYNAME.Series} closeForm={() => setOpenSeriesSelection(!openSeriesSelection)} setDataList={onSelectionSeries} title={lang.select_series_collection_header} mode={"single"} width={"50vw"} />}
      {openTMDB && (
        <TMDBEditForm
          cancelEdit={() => setOpenTMDB(false)}
          allowSingleSeasonSelect={true}
          onSelectSeason={handleTMDBSeasonSelect}
        />
      )}

      {showEditForm.Content && <ContentEditForm item={{ SID: 0 }} cancelEdit={() => setShowEditForm(false)} refresh={() => loadcombo()} filterMediaCategory={props.mediaCategory} />}
      {showTranslateForm && <LanguageTranslator onSubmit={handleLangugaeTranslate} cancelEdit={() => setShowTranslateForm(false)} />}
      {showEditForm.Genre && <GenreEditForm item={{ SID: 0 }} cancelEdit={() => setShowEditForm(false)} refresh={() => loadcombo()} />}
      {/* Image Content Popup */}
      {openImageInput && <MMImageEditForm onClose={() => setOpenImageInput(false)} selectedImageUrl={dataItem.ImageUrl} setDataList={(img) => { setSelectedImageUrl(img); setDataItem({ ...dataItem, ["ImageUrl"]: img }) }} />}
      {openImageBrowse && <MMImageEditForm onClose={() => setOpenImageBrowse(false)} isBrowse={true} selectedImageUrl={dataItem.ImageUrl} setDataList={(img) => { setSelectedImageUrl(img); setDataItem({ ...dataItem, ["ImageUrl"]: img }) }} />}
      {openMediaEpisodeSettingForm && <MediaEpisodeSettingForm onCancel={() => setOpenMediaEpisodeSettingForm(false)} entityName={entityName} data={dataItem} setData={setDataItem} />}
    </div>
  )
}

export default SeasonDetailForm
